import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  stepCircle,
  timeline,
  blueShadow,
  greenShadow,
  grayShadow,
} from './style.scss';

const TrackCourseItem = ({
  children,
  step,
  last = false,
  courseProgress,
  newCourse = false,
}) => {
  return (
    <div className="relative pv3 ph6-l ph3-m ph2-ns">
      <div
        className={cx('absolute right-0 bl db-ns dn', timeline, {
          'top-0 bottom-0': step > 1 && !last,
          'top-0 h-50': last,
          'bottom-0 h-50': step === 1,
        })}
      />
      {step && (
        <button
          aria-label="Track course item"
          className={cx(
            'absolute right-0 outline-0 bn pa0 br-100 tc db-ns dn',
            stepCircle,
            {
              [`${blueShadow} bg-blue white`]:
                courseProgress !== 'completed' && !newCourse,
              [`${greenShadow} bg-green-light white`]:
                courseProgress === 'completed' && !newCourse,
              [`${grayShadow} bg-near-white silver`]: newCourse,
            },
          )}
        >
          {step}
        </button>
      )}
      <div className="ph3">{children}</div>
    </div>
  );
};

TrackCourseItem.propTypes = {
  step: PropTypes.number,
  children: PropTypes.node,
  last: PropTypes.bool,
  courseProgress: PropTypes.string.isRequired,
  newCourse: PropTypes.bool,
};

export default TrackCourseItem;
